module.exports = __webpack_public_path__ + "img/571.f8c37aca.jpg";